import { create } from 'zustand'
import { INITIAL_ZOOM } from '../components/map/types.ts'

interface MapState {
    googleLoaded: boolean
    setGoogleLoaded: (b: boolean) => void

    map: google.maps.Map | null
    setMap: (map: google.maps.Map | null) => void

    bounds: google.maps.LatLngBounds | null
    setBounds: (bounds: google.maps.LatLngBounds) => void
    // maps: any  // the google map api
    // setMaps: (maps: any) => void

    google: any  // the google map api
    setGoogle: (maps: any) => void

    circles: any[]
    setCircles: (p: any[]) => void

    mapStyle: string
    setMapStyle: (s: string) => void

    webSocketConnected: boolean
    setWebSocketConnected: (b: boolean) => void

    zoom: number
    setZoom: (z: number) => void

    myPosition: google.maps.LatLng | null
    setMyPosition: (p: google.maps.LatLng) => void

    historyMapHeight: number,
    setHistoryMapHeight: (height: number) => void

    historyZoom: number
    setHistoryZoom: (z: number) => void

    mapContext: 'map' | 'history',
    setMapContext: (c: 'map' | 'history') => void

    markerInfo: string | null,
    setMarkerInfo: (i: string | null) => void

    directionsTo: google.maps.LatLng | null
    setDirectionsTo: (p: google.maps.LatLng | null) => void

    travelMode: google.maps.TravelMode | null
    setTravelMode: (p: google.maps.TravelMode | null) => void

    locationEnabled: boolean
    setLocationEnabled: (p: boolean) => void

    showMapStyle: boolean
    setShowMapStyle: (p: boolean) => void

    reset: () => void
}

// @ts-ignore
const _mapStyle = JSON.parse(localStorage.getItem('mapStyle'))
// @ts-ignore
const _savedMapState = JSON.parse(localStorage.getItem('mapState')) || {}

const useStore = create<MapState>((set) => ({
    googleLoaded: false,
    setGoogleLoaded: (googleLoaded: boolean) =>
        set((state) => ({
            ...state,
            googleLoaded
        })),

    map: null,
    setMap: (map: any) =>
        set((state) => ({
            ...state,
            map
        })),

    maps: null,
    setMaps: (maps: any) =>
        set((state) => ({
            ...state,
            maps
        })),

    bounds: null,
    setBounds: (bounds: google.maps.LatLngBounds) =>
        set((state) => ({
            ...state,
            bounds
        })),

    google: null,
    setGoogle: (google: any) =>
        set((state) => ({
            ...state,
            googleLoaded: !!google,
            google
        })),

    circles: [],
    setCircles: (circles: any[]) =>
        set((state) => ({
            ...state,
            circles
        })),

    mapStyle: _mapStyle || 'default',
    setMapStyle: (mapStyle: string) =>
        set((state) => ({
            ...state,
            mapStyle
        })),

    webSocketConnected: false,
    setWebSocketConnected: (webSocketConnected: boolean) =>
        set((state) => ({
            ...state,
            webSocketConnected
        })),

    zoom: _savedMapState.zoom || INITIAL_ZOOM,
    setZoom: (z: number) => {
        const newZoom = z > 22 ? 22 : z
        set((state) => ({
            ...state,
            zoom: newZoom,
        }))
        // Save to localStorage for main map only (not history)
        const currentState = useStore.getState()
        if (currentState.mapContext === 'map') {
            const center = currentState.map?.getCenter()
            if (center) {
                localStorage.setItem('mapState', JSON.stringify({
                    zoom: newZoom,
                    center: { lat: center.lat(), lng: center.lng() }
                }))
            }
        }
    },

    historyZoom: INITIAL_ZOOM,
    setHistoryZoom: (historyZoom: number) =>
        set((state) => ({
            ...state,
            historyZoom,
        })),


    myPosition: null,
    setMyPosition: (myPosition: google.maps.LatLng) =>
        set((state) => ({
            ...state,
            myPosition
        })),

    historyMapHeight: 0,
    setHistoryMapHeight: (historyMapHeight: number) =>
        set((state) => ({
            ...state,
            historyMapHeight,
        })),

    mapContext: 'map' as 'map' | 'history',
    setMapContext: (mapContext: 'map' | 'history') =>
        set((state) => ({
            ...state,
            mapContext,
        })),

    markerInfo: null,
    setMarkerInfo: (markerInfo: string | null ) =>
        set(state => ({
            ...state,
            markerInfo
        })),

    directionsTo: null,
    setDirectionsTo: (directionsTo: google.maps.LatLng | null) =>
        set((state) => ({
            ...state,
            directionsTo
        })),

    travelMode: '' as google.maps.TravelMode,
    setTravelMode: (travelMode: google.maps.TravelMode | null) =>
        set((state) => ({
            ...state,
            travelMode
        })),

    locationEnabled: true,
    setLocationEnabled: (locationEnabled: boolean) =>
        set((state) => ({
            ...state,
            locationEnabled
        })),

    showMapStyle: false,
    setShowMapStyle: (showMapStyle: boolean) =>
        set((state) => ({
            ...state,
            showMapStyle
        })),

    reset: () =>
        set((state) => ({
            ...state,
            map: null,
            maps: null,
            circles: [],
            zoom: INITIAL_ZOOM,
            historyZoom: INITIAL_ZOOM,
            bounds: null,
            historyMapHeight: 0,
            mapContext: 'map',
            markerInfo: null,
            travelMode: google.maps.TravelMode.WALKING,
            directionsTo: null,
            showMapStyle: false,
        })),
}));

export default useStore;
